import React, { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import AdminFinance from "./AdminFinance";
import classes from "./AdminFinance.module.css";
import { useMediaQuery } from "@mui/material";
import MovingBetweenCashRegister from "./MovingBetweenCashRegister";
import useLang from "../../hooks/useLang";
import UserCashRegisterManager from "./UserCashRegister";
import CashRegisterTable from "./CashRegisterTable";
import CashRegisterManager from "./CashRegisterManager";

const AdminFinanceTabs = () => {
	const [selectedTab, setSelectedTab] = useState(0);

	const handleTabChange = (event: any, newValue: any) => {
		setSelectedTab(newValue);
	};
	const isMobile = useMediaQuery("(max-width:600px), (min-width:600px)");

	const { strings } = useLang("adminFinance");
	useEffect(() => {
		if (!strings) {
			return;
		}
	}, [strings]);

	return (
		<div className={classes.mainTabsContainer}>
			<div className="w-full flex justify-center items-center">
				<Tabs
					value={selectedTab}
					onChange={handleTabChange}
					className={classes.mainTabs}
					variant={isMobile ? "scrollable" : "standard"}
					scrollButtons="auto"
					centered={!isMobile}
					allowScrollButtonsMobile
					sx={{
						"& .css-k008qs": {
							display: "flex",
							justifyContent: "space-between",
						},
					}}
				>
					<Tab label={strings?.tabs.firstTab} />
					<Tab label={strings?.tabs.secondTab} />
					<Tab label={strings?.tabs.thirdTab} />
					<Tab label={strings?.tabs.fourthTab} />
					<Tab label={strings?.tabs.fifthTab} />
				</Tabs>
			</div>
			{selectedTab === 0 && <AdminFinance />}
			{selectedTab === 1 && <MovingBetweenCashRegister />}
			{selectedTab === 2 && <UserCashRegisterManager />}
			{selectedTab === 3 && <CashRegisterTable />}
			{selectedTab === 4 && <CashRegisterManager />}
		</div>
	);
};

export default AdminFinanceTabs;
